import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';

// Debug: confirm CRA injected REACT_APP_* from .env at build/start (DevTools → Console)
// console.log('[WorkBiFlow env] Firebase from process.env', {
//   REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
//   REACT_APP_FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   REACT_APP_FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   REACT_APP_FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   REACT_APP_FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
//   REACT_APP_FIREBASE_VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY
// });


const root = ReactDOM.createRoot(document.getElementById('root'));
// Defensive: wrap native removeChild to avoid Uncaught NotFoundError thrown by
// mutations originating outside React's reconciliation (prevents white-screen).
// We only catch the specific NotFoundError and re-throw other errors.
try {
  const _origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    try {
      return _origRemoveChild.call(this, child);
    } catch (err) {
      // Some browsers throw a DOMException with name 'NotFoundError'
      if (err && (err.name === 'NotFoundError' || err.code === 8)) {
        // Log for debugging but avoid crashing the whole app.
        // Include stack to trace where the removal originated.
        const stack = (new Error()).stack;
        // eslint-disable-next-line no-console
        console.warn('Ignored removeChild NotFoundError', { err, parent: this, child, stack });
        try {
          if (!window.__removedChildErrors) window.__removedChildErrors = [];
          window.__removedChildErrors.push({ time: Date.now(), parentTag: this?.tagName, childNodeType: child?.nodeType, stack });
        } catch (e) {}
        return child;
      }
      throw err;
    }
  };
} catch (e) {
  console.warn('Could not patch Node.prototype.removeChild', e);
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
